import React from 'react'
import PropTypes from 'prop-types'
import useIsHydrated from '../Hooks/useIsHydrated'

function EmailText({ email, linkClass }) {
  const isHydrated = useIsHydrated()
  if (!isHydrated) return null
  return (
    <a href={`mailto:${email}`} className={linkClass}>
      {email}
    </a>
  )
}

EmailText.propTypes = {
  email: PropTypes.string.isRequired,
  linkClass: PropTypes.string.isRequired
}

export default EmailText
